import {RGBAColor} from "@deck.gl/core/utils/color";

export const primaryColor: RGBAColor = [66, 199, 167];
export const lightPurpleColor: RGBAColor = [163, 150, 240];
export const darkPurpleColor: RGBAColor = [133, 116, 236];
export const peachColor: RGBAColor = [255, 144, 129];
export const cyanColor: RGBAColor = [121, 201, 224];
export const offWhiteColor: RGBAColor = [244, 243, 251];
export const grayColor: RGBAColor = [32, 38, 29];
